module.exports = __webpack_public_path__ + "static/media/Logo.12b91cb0.png";